import { Box, Image, Link } from "@chakra-ui/react"
import { PublicationBlockGalleryPublic } from "../../client"

import LightGallery from "lightgallery/react"
import lgZoom from "lightgallery/plugins/zoom"
import lgThumbnail from "lightgallery/plugins/thumbnail"

import "lightgallery/css/lightgallery.css"
import "lightgallery/css/lg-thumbnail.css"
import "lightgallery/css/lg-zoom.css"

const LIGHT_GALLERY_LICENSE_KEY = import.meta.env.VITE_LIGHT_GALLERY_LICENSE_KEY

const GalleryBlock = ({ data }: { data: PublicationBlockGalleryPublic }) => {

    return (
        <Box
            my={10}
            css={{
                columnCount: { base: 1, md: 2, lg: 3 },
                columnGap: "16px",
                "& a": { breakInside: "avoid" }
            }}
        >
            <LightGallery
                speed={500}
                licenseKey={LIGHT_GALLERY_LICENSE_KEY}
                plugins={[lgThumbnail, lgZoom]}
                elementClassNames="custom-gallery"
                selector="a"
                download={false}
                getCaptionFromTitleOrAlt={false}
            >
                {data.fk_gallery_images.map((img, index) => (
                <Link
                    key={index}
                    href={img.fk_media.path}
                    data-src={img.fk_media.path}
                >
                    <Image
                    src={img.fk_media.path.replace(/-(LG)\./, "-MD.")}
                    alt={img.fk_media.file_name}
                    mb="16px"
                    cursor="pointer"
                    _hover={{ opacity: 0.8 }}
                    />
                </Link>
                ))}
            </LightGallery>
        </Box>

    )
}

export default GalleryBlock